module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"print":"Print..."},"fi":{"print":"Tulosta..."},"sv":{"print":"Skriv ut..."},"de":{"print":"Drucken..."},"ko":{"print":"인쇄"}}')
  delete Component.options._Ctor
}
